import axios from "axios";
import Cookies from "js-cookie";
export const BACKEND_URL = "https://api.endless-recs.com";

export function l(thing) {
  console.log({ thing });
  console.log(thing);
  console.log({ thing });
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getTracks(setTracks, tracksState, setTracksLoading) {
  async function getTracksFunction() {
    try {
      setTracksLoading(true);
      const response = await axios.post(
        `${BACKEND_URL}/tracks`,
        { tracksState },
        {
          withCredentials: true,
        }
      );
      setTracks(response.data.tracks);
      setTracksLoading(false);
      return response.data.tracks;
    } catch (error) {
      setTracksLoading(false);
      console.error("Error fetching tracks", error);
    }
  }
  return getTracksFunction;
}

export function getRecommendations(
  recommendationsState,
  setRecommendations,
  setRecommendationsLoading,
  ignoreInputTracks
) {
  if (ignoreInputTracks === true || ignoreInputTracks === "true") {
    recommendationsState.tracks = "";
  }
  const getRecommendationsFunction = async () => {
    try {
      setRecommendationsLoading(true);

      const response = await axios.post(
        `${BACKEND_URL}/recommendations`,
        { recommendationsState },
        { withCredentials: true }
      );

      setRecommendationsLoading(false);

      setRecommendations(response.data.recommendations);
      return response.data.recommendations;
    } catch (err) {
      setRecommendationsLoading(false);

      console.error("Error fetching recommendations", err);
    }
  };
  return getRecommendationsFunction;
}

export function createPlaylist(
  recommendations,
  playlistState,
  setCreatePlaylist,
  setPlaylist
) {
  const createPlaylistFunction = async () => {
    try {
      setCreatePlaylist(true);
      const response = await axios.post(
        `${BACKEND_URL}/playlist`,
        { recommendations, playlistState },
        { withCredentials: true }
      );
      if (response.data.success) {
        // await sleep(2000);
        setCreatePlaylist(false);
        setPlaylist(response.data.playlist);
      } else {
        setCreatePlaylist(false);
      }
    } catch (err) {
      setCreatePlaylist(false);
      console.error("Error creating playlist", err);
    }
  };
  return createPlaylistFunction;
}

export function resampleGeneratePlaylist(
  setTracks,
  recommendationsState,
  setRecommendations,
  playlistState,
  tracksState,
  setResampleGeneratePlaylistLoading,
  setTracksLoading,
  setRecommendationsLoading,
  setCreatePlaylistLoading,
  setPlaylist,
  ignoreInputTracks,
  alwaysResample
) {
  const resampleGeneratePlaylistFunction = async () => {
    try {
      setResampleGeneratePlaylistLoading(true);
      let tracks = recommendationsState.tracks;
      if (
        alwaysResample === "true" ||
        alwaysResample === true ||
        tracks == ""
      ) {
        tracks = await (
          await getTracks(setTracks, tracksState, setTracksLoading)
        )();
      }
      const recommendations = await (
        await getRecommendations(
          { tracks, temperature: recommendationsState.temperature },
          setRecommendations,
          setRecommendationsLoading,
          ignoreInputTracks
        )
      )();
      await (
        await createPlaylist(
          recommendations,
          playlistState,
          setCreatePlaylistLoading,
          setPlaylist
        )
      )();
      setResampleGeneratePlaylistLoading(false);
    } catch (err) {
      setResampleGeneratePlaylistLoading(false);
      console.error("Error generating recs", err);
    }
  };
  return resampleGeneratePlaylistFunction;
}

export function accessTokenSet() {
  return Cookies.get("token_set") === "true";
}

export const handleEventChange = (setSomeState, cookieName, allowCookies) => {
  const handleEventChangeFunction = (event) => {
    if (allowCookies) {
      setCookie(cookieName, encodeURIComponent(event.target.value));
    }
    setSomeState(event.target.value);
  };
  return handleEventChangeFunction;
};

export const handleToggleClick = (toggleState, setToggleState, cookieName) => {
  const handleToggleClickFunction = (event) => {
    const value = (event.target.value === "on") !== toggleState;
    setToggleState(value);
    setCookie(cookieName, value.toString());
  };
  return handleToggleClickFunction;
};

export function getCookie(name) {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();

    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }

  return "";
}

export function setCookie(name, value, days = 3650) {
  if (getCookie("allow_cookies") !== "" || name === "allow_cookies") {
    let expires = "";

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
}

export function clearCookiesExcept(keepList) {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const name = cookie.trim().split("=")[0];

    if (!keepList.includes(name)) {
      document.cookie =
        name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // Optional, smooth scrolling effect
  });
}

export function getUserPlaylists(setAllPlaylists) {
  const getUserPlaylistsFunction = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/playlists`, {
        withCredentials: true,
      });

      setAllPlaylists(response.data.playlists);
    } catch (error) {
      console.error("Error fetching user playlists", error);
    }
  };
  return getUserPlaylistsFunction;
}
